/*=========================================================================================
  File Name: modulePersonnel.js
  Description: Calendar Module
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import state from './moduleFonddecaisseState.js'
import mutations from './moduleFonddecaisseMutations.js'
import actions from './moduleFonddecaisseActions.js'
import getters from './moduleFonddecaisseGetters.js'

export default {
  isRegistered: false,
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

